import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import KshitiHeadshot from '../images/Kshiti Headshot.svg';
import AwardFinalist from '../images/Award Finalist.png';

const Home = () => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div>
      <Helmet>
        <title>Kshiti :: Home</title>
      </Helmet>
      <section className="home-hero">
        <div className="row">
          <div className="col home-hero-content">
            <h1>
              Hello, <span className="hover-change-text">{hovered ? 'Namaste' : 'नमस्ते!'}</span>
              <span
                className="hover-me-text highlight-color"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                (hover me)
              </span>
              <br />
              My name is <span className="highlight-color">Kshiti.</span>
            </h1>
            <h2>
              Front-End - <span className="highlight-color">Designer <br /> And Developer.</span>
            </h2>
            <p>
              I love bringing ideas to life on the web with clean code and creative visuals. My focus is on designs that feel accessible, simple, and easy to use. Always learning, always building, and always excited to collaborate.
            </p>
          </div>
          <div className="col">
            <div className="hero-image">
              <img src={AwardFinalist} alt="Tech Forward Award Finalist" className="hero-image-2" />
              <img src={KshitiHeadshot} alt="Kshiti Headshot" className="hero-image-1" />
            </div>
          </div>
        </div>
      </section>
      <section className="home-skills container">
        <div className="row">
          <div className="col">
            <div className='container'>
              <h6>
                <span>01</span><span className="container-heading home-skills-heading">Designer</span>
              </h6>
            <div className="container-content home-skills-content">
              <p>I value simple content structure, clean design patterns, and thoughtful interactions.</p>
              <p className="primary-highlight">Things I enjoy designing:</p>
              <p>UX, UI, Web, SVGs</p>
              <p className="primary-highlight">Design Tools:</p>
              <ul>
                <li>Photoshop</li>
                <li>Figma</li>
                <li>Adobe XD</li>
                <li>Canva</li>
                <li>WebAIM</li>
              </ul>
            </div>
            </div>
          </div>
          <div className="col">
          <div className='container'>
              <h6>
                <span>02</span><span className="container-heading home-skills-heading">Front-end Developer</span>
              </h6>
              <div className="container-content home-skills-content">
                <p>I like to code things from scratch, and enjoy bringing ideas to life in the browser.</p>
                <p className="primary-highlight">Languages I speak:</p>
                <p>HTML, CSS, Bootstrap, JavaScript, Liquid, API, React, C#, SQL </p>
                <p className="primary-highlight">Development Tools:</p>
                <ul>
                  <li>WordPress CMS</li>
                  <li>Shopify</li>
                  <li>VS Code Editor</li>
                  <li>GitHub</li>
                  <li>Firebase Console</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-web primary-background">
        <div className='container'>
          <h6>
            <span>03</span><span className="container-heading">Around the web - It's about being visible in the right places, in front of right people and above all - to stand out.</span>
          </h6>
        <div className="container-content home-web-content">
          <h6><a href="https://bootsnipp.com/kshiti06" target='_blank' rel="noopener noreferrer">Bootsnipp</a></h6>
          <h6><a href="https://blog.prototypr.io/50-best-free-bootstrap-form-templates-examples-in-2019-79e4501dd7c6" target='_blank' rel="noopener noreferrer">Prototypr.io</a></h6>
          <h6><a href="https://essentialwebapps.com/bootstrap/bootstrap-profiles/" target='_blank' rel="noopener noreferrer">Essential Web Apps</a></h6>
          <h6><a href="https://bootstrapious.com/p/profiles" target='_blank' rel="noopener noreferrer">Bootstrapious</a></h6>
          <h6><a href="https://webartdevelopers.com/blog/bootstrap-profile-page-design/" target='_blank' rel="noopener noreferrer">Web Art Developers</a></h6>
          <h6><a href="https://www.mockplus.com/blog/post/bootstrap-form-template" target='_blank' rel="noopener noreferrer">Mockplus</a></h6>
        </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
